import { render, staticRenderFns } from "./forgetPd.vue?vue&type=template&id=b65e4348&"
import script from "./forgetPd.vue?vue&type=script&lang=js&"
export * from "./forgetPd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports